import { decodeHtmlEntities } from '@/utils/decodeHtmlEntities';
import type { SiloData, SiloLink } from '@/types/app';
import './SiloSidebar.scss';

interface SiloSidebarProps {
  silo: SiloData;
}

function isMeaningfulLink(link?: SiloLink): link is SiloLink {
  return !!link && !!link.title?.trim() && !!link.url?.trim();
}

export function SiloSidebar({ silo }: SiloSidebarProps) {
  // Build a flat, deduplicated list — most contextual first:
  // parent → grandparent → children → grandchildren → siblings (least contextual)
  const all: SiloLink[] = [];

  if (isMeaningfulLink(silo.parent)) all.push(silo.parent);
  if (isMeaningfulLink(silo.grandparent)) all.push(silo.grandparent);
  for (const link of silo.children ?? []) {
    if (isMeaningfulLink(link)) all.push(link);
  }
  for (const link of silo.grandchildren ?? []) {
    if (isMeaningfulLink(link)) all.push(link);
  }
  for (const link of silo.siblings ?? []) {
    if (isMeaningfulLink(link)) all.push(link);
  }

  // Deduplicate by id
  const seen = new Set<number>();
  const links = all.filter((link) => {
    if (seen.has(link.id)) return false;
    seen.add(link.id);
    return true;
  });

  if (links.length === 0) return null;

  return (
    <aside className="silo-sidebar">
      <nav aria-label="Menu thématique">
        <div className="silo-sidebar__title">À lire dans cette thématique</div>
        <ul className="silo-sidebar__list">
          {links.map((item) => (
            <li key={item.id} className="silo-sidebar__item">
              <a href={item.url} className="silo-sidebar__link">
                {decodeHtmlEntities(item.title)}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default SiloSidebar;
